export default "__VITE_ASSET__D9F8z3nt__"